module.exports = __webpack_public_path__ + "img/fidelity-voucher.5e91e140.jpg";